import React from "react";
import { Coffee, Heart } from "lucide-react";
import SEO from "../components/SEO";

export default function Donate() {
    return (
        <div className="min-h-screen bg-spiritual-white dark:bg-gray-950 flex items-center justify-center p-6 font-body">
            <SEO 
              title="Donate" 
              description="Help us keep the sanctuary independent and ad-free. Your support fuels our mission of quiet, safe, and human-first technology." 
              url="/donate" 
            />

            <div className="max-w-md w-full text-center space-y-8">

                <div className="flex justify-center">
                    <div className="relative">
                        <div className="absolute inset-0 bg-yellow-400 blur-xl opacity-20 rounded-full"></div>
                        <div className="relative w-24 h-24 bg-gradient-to-br from-yellow-100 to-amber-100 dark:from-yellow-900/30 dark:to-amber-900/30 rounded-full flex items-center justify-center text-amber-500 mx-auto">
                            <Coffee className="w-12 h-12" />
                        </div>
                    </div>
                </div>

                <div className="space-y-4">
                    <h1 className="text-3xl font-display font-medium text-gray-900 dark:text-white">
                        Fuel the Journey
                    </h1>
                    <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                        Antaryatra is free, open, and built by a human (me!).
                        If this space has helped you, or if you believe in the mission of quiet, safe tech—consider buying me a coffee.
                    </p>
                </div>

                <div className="space-y-4">
                    <a
                        href="https://buymeacoffee.com/joey"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block w-full py-4 bg-[#FFDD00] text-black font-bold rounded-xl hover:bg-[#FFEA00] transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-1 active:translate-y-0"
                    >
                        <div className="flex items-center justify-center gap-2">
                            <Coffee className="w-5 h-5" />
                            Buy Me a Coffee
                        </div>
                    </a>

                    <p className="text-xs text-gray-400 px-8">
                        Your support covers server costs and keeps the late-night coding sessions fueled. 💛
                    </p>
                </div>

                <div className="pt-8 border-t border-gray-100 dark:border-gray-800">
                    <p className="text-sm text-gray-500">
                        Put your BuyMeACoffee link above in <code className="bg-gray-100 dark:bg-gray-800 px-1 py-0.5 rounded">src/pages/Donate.jsx</code>.
                    </p>
                </div>

            </div>
        </div>
    );
}
